<table class="myDpYearTable" [ngClass]="{'ng-myrtl': opts.rtl, 'myDpFooter': opts.showFooterToday, 'myDpNoFooter': !opts.showFooterToday, 'myDpViewChangeAnimation': opts.viewChangeAnimation && viewChanged}">
  <tbody>
    <tr *ngFor="let yr of years">
      <td id="y_{{y.row}}_{{y.col}}" class="y_{{y.row}}_{{y.col}} myDpYearcell"
          [ngClass]="{'myDpSelectedYear': y.selected, 'myDpDisabled': y.disabled, 'myDpTableSingleYear': !y.disabled}"
          *ngFor="let y of yr" (click)="onYearCellClicked($event, y)" (keydown)="onYearCellKeyDown($event, y)" [attr.tabindex]="!y.disabled ? 0 : -1">
        <span class="myDpYearValue" 
          [attr.aria-label]="[(1 + '/' + 1 + '/' + y.year | date:'yyyy')]"
          [ngClass]="{'myDpMarkCurrYear': y.currYear && opts.markCurrentYear}">{{y.year}}</span>
      </td>
    </tr>
  </tbody>
</table>
